/**
 * @description 保單檢核區分要保人/被保人用
*/
export enum RuleCheckInsuredType {
  /** 要保人 */
  Applicant = '1',
  /** 被保人 */
  Insured = '2'
};
